import React from "react";
import TextField from "@mui/material/TextField";
import { RegisterInputData, RegistrationFieldReferences } from "./PublicRegister";
import { Title } from "@shared/mirage/core/enums";
import { MenuItem } from "@mui/material";
import InputErrorMessage from "@mirage/components/inputErrorMessage/InputErrorMessage";

interface SecondStepFieldsProps {
    titleData: RegisterInputData;
    firstNameData: RegisterInputData;
    lastNameData: RegisterInputData;
    onChangeHandler: (value: string, inputReference: RegistrationFieldReferences) => void;
    onBlurHandler: (inputReference: RegistrationFieldReferences) => void;
}

const SecondStepFields: React.FC<SecondStepFieldsProps> = ({ titleData, firstNameData, lastNameData, onChangeHandler, onBlurHandler }): JSX.Element => {
    return (
        <>
            <TextField
                sx={{ width: "60%" }}
                id="register-title"
                label="Title"
                error={!titleData.validationResult.passed}
                helperText={<InputErrorMessage passed={titleData.validationResult.passed} message={titleData.validationResult.error} />}
                onChange={(e) => onChangeHandler(e.target.value, "title")}
                onBlur={() => onBlurHandler("title")}
                variant="outlined"
                value={titleData.value}
                required
                select
            >
                {Object.values(Title).map((title) => {
                    return (
                        <MenuItem key={title} value={title}>
                            {title}
                        </MenuItem>
                    );
                })}
            </TextField>
            <TextField
                sx={{ width: "60%" }}
                required={true}
                id="register-firstName"
                error={!firstNameData.validationResult.passed}
                value={firstNameData.value}
                helperText={<InputErrorMessage passed={firstNameData.validationResult.passed} message={firstNameData.validationResult.error} />}
                onChange={(e) => onChangeHandler(e.target.value, "firstName")}
                onBlur={() => onBlurHandler("firstName")}
                label="First Name"
                variant="outlined"
            />
            <TextField
                sx={{ width: "60%" }}
                required={true}
                id="register-lastName"
                error={!lastNameData.validationResult.passed}
                value={lastNameData.value}
                helperText={<InputErrorMessage passed={lastNameData.validationResult.passed} message={lastNameData.validationResult.error} />}
                onChange={(e) => onChangeHandler(e.target.value, "lastName")}
                onBlur={() => onBlurHandler("lastName")}
                label="Last Name"
                variant="outlined"
            />
        </>
    );
};

export default SecondStepFields;
